module.exports = __webpack_public_path__ + "static/assets/cb0b3132e926a32505fbd25af018203c.png";